import { bindingTypes } from '@adalo/constants'

import { evaluateCondition } from './conditions'
import { evaluateBinding, getBindingValue } from './dependencies'

export const getVisible = (state, object, opts) => {
  const { visibility = {} } = object.attributes

  if (
    !visibility ||
    !visibility.source ||
    visibility.bindingType !== bindingTypes.VISIBILITY
  ) {
    return true
  }

  const { comparator, source } = visibility

  const binding = evaluateBinding(state, visibility, opts)
  const comp1 = getBindingValue(visibility.comparison, { ...opts, state })
  const comp2 = getBindingValue(visibility.comparison2, { ...opts, state })

  return evaluateCondition(binding, comparator, source.dataType, comp1, comp2)
}
